<template>
  <v-tooltip bottom :open-delay="openDelay" :close-delay="closeDelay" :disabled="tooltipDisabled">
    <template v-slot:activator="{ on }">
      <span v-on="tip ? on : null"><!-- 10 Oct 2025 JCH tooltip active when disabled -->
        <!-- 10 Oct 2025 JCH pass event for stop/prevent -->
        <v-btn
              :a="a"
              class=""
              :class="btnclass"
              @click="raiseClickEvent($event)"
              :color="color"
              :disabled="disabled"
              :elevation="elevation"
              :fab="fab"
              :icon="icon"
              :loading="loading"
              :small="small"
              :stop="stop"
              :style="btnstyle"
              :text="text"
              :tile="tile"
              :x-large="xlarge"
              :x-small="xsmall"
          ><a :href="href">
            <v-icon
                  :color="icolor"
                  :class="iclass"
                  :small="ismall"
                  :style="istyle"
                  v-if="icon || fab"
        >
            {{ iname }}
            </v-icon>
          </a>
          <span class="hidden-sm-and-down">{{ hideSmDown +  txt + hideSmDownAfter}}</span>
          <span class="hidden-md-and-up">{{ txt }}</span>
        </v-btn>
      </span>
    </template>
    <span> {{ tip }} </span>
  </v-tooltip>
</template>

<script>
export default {
  name: "ButtonTip",
  props: {
    a: { type: Boolean, default: false },
    btnclass: { type: String, default: "" },
    btnstyle: { type: String, default: "" },
    color: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    elevation: { type: String, default: "" },
    fab: { type: Boolean, default: false },
    hideSmDown: { type: String, default: "" },
    hideSmDownAfter: { type: String, default: "" },
    href: { type: String, default: "" },
    icon: { type: Boolean, default: false },
    iname: { type: String, default: "" },
    iclass: { type: String, default: "" },
    icolor: { type: String, default: "" },
    ismall: { type: Boolean, default: false },
    istyle: { type: String, default: "color: rgba(0, 0, 0, 0.54)" },// custom grey default
    loading: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
    stop: { type: Boolean, default: false },
    tile: { type: Boolean, default: false },
    text: { type: Boolean, default: false },
    txt: { type: String, default: "" },
    tip: { type: String, default: "" },
    xlarge: { type: Boolean, default: false },
    xsmall: { type: Boolean, default: false },
    openDelay: { type: Number, default: 200 }, // 31 Dec 2025 JCH
    closeDelay: { type: Number, default: 150 },
    tooltipDisabled: { type: Boolean, default: false },
  },

  data: () => ({
    space: ' ',
    internalTooltipDisabled: false,
  }),

  methods: {
    raiseClickEvent(e) { // 10 Oct 2025 JCH safe event handling for stop/prevent
      if (this.stop && e) e.stopPropagation(); // 10 Oct 2025 JCH stop bubbling
      if (!this.href && e) e.preventDefault(); // 10 Oct 2025 JCH block nav without href
      this.internalTooltipDisabled = true; // 31 Dec 2025 JCH Disable tooltip when button is clicked
      setTimeout(() => {
        this.internalTooltipDisabled = false; // 31 Dec 2025 JCH Re-enable after short delay
      }, 100);
      this.$emit('click');
    },
  },
};
</script>